import { useState } from "react";
import { checkCircleIcon, minusIcon, tagIcon } from "../../../constants/icons";
import { Button } from "react-bootstrap";

function ExamPaperFooter({ subject, paper, year, markingSchemeContent }) {
    const [schemeExpand, setSchemeExpand] = useState(false);

    const schemeHandler = (e) => {
        e.stopPropagation();
        setSchemeExpand(prevState => !prevState);
    };

    return (
        <>
            <div className="footer-tag-container">
                <div className="tag-wrappper">
                    <div className="tag-info">
                        {tagIcon}
                        <span>{subject}</span>
                    </div>
                    <span className="tag-badge">{paper}</span>
                    <span className="tag-badge">{year}</span>
                </div>
                <Button className="view-making-scheme-btn" variant="outline-primary" onClick={schemeHandler}>
                    {schemeExpand ? minusIcon : checkCircleIcon} View Marking Scheme
                </Button>
            </div>
            {schemeExpand && <div className="marking-scheme-content">{markingSchemeContent}</div>}
        </>
    );
}

export default ExamPaperFooter;
